import { reduce, pathOr } from 'ramda';

/**
 * groupByWith
 *
 * groupByWith is our own groupBy implementation using reduce of ramda and
 * pathOr
 *
 * Don't use the groupBy of ramda, as it has a hardstop when it hits a predicate
 * that return false, which mean you don't iterate the full array and will
 * produce random half baked results.
 *
 *  The below implementation uses reduces and iterats over the full array
 *  We have the ability to  groupby not just the parent key but like
 *  - object_meta.labels.category.
 *
 * @param data { array } The path to use to group with.
 *
 */
export const groupByWith = (paths: string[]) => {
  return reduce((groups, item) => {
    const p = pathOr('', paths, item);
    groups[p] = groups[p] || [];
    groups[p].push(item);
    return groups;
  }, {});
};
